"use strict";

import "babel-polyfill";
import coreFactory from "./common/core";
import sandboxFactory from "./common/sandbox";

// Modules
import monthlySummaryReports from "./viewing-summary/tv-sets-viewing/tv-sets-viewing-reports";
import moreInfo from "./top-programmes/more-info-button-icon";

const core = coreFactory(window.jQuery, sandboxFactory);

core.createModule(
    "tv_sets_viewing",
    monthlySummaryReports("viewing-report/tv-sets-monthly-viewing/data", {csvName: 'Tv-sets-viewing.csv'})
);

jQuery(() => {
    core.createModule("toolbox", moreInfo);
    core.startAll();
});


